import styled, { css } from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';
import { TYPOGRAPHY } from 'brand-guidelines/typography';
import { H3, P } from 'common/styles/oc-styled-components';
import { BREAKPOINTS } from 'common/styles/style-constants';

const WRAPPER_MARGIN_TOP = 10;
const WRAPPER_HORIZONTAL_PADDING = 16;

export const BookingWidgetWrapper = styled.div.attrs({ as: 'aside' })`
  display: flex;

  flex-direction: column;
  justify-content: center;
  align-items: stretch;
  gap: 20px;

  padding: 24px ${WRAPPER_HORIZONTAL_PADDING}px;
  ${({ $addTopPadding }) => $addTopPadding && css`
    padding-top: 0;
  `}

  background-color: ${BRAND_COLORS.white};
  border: 1px solid ${BRAND_COLORS.lightGray};
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 0px 5px 0px #e2e2e2;

  @media (max-width: ${BREAKPOINTS.tabletMax}px) {
    position: static;
    width: 100%;
    margin: ${WRAPPER_MARGIN_TOP}px 0 0 0;
  }

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    /* The element above the booking widget is shifted up by 45px, so we need to offset it here */
    margin: ${-45 + WRAPPER_MARGIN_TOP}px 0 0 0;
  }
`;

export const OfferBlock = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  background: ${BRAND_COLORS.red};

  width: calc(100% + ${WRAPPER_HORIZONTAL_PADDING * 2}px);
  margin-left: -${WRAPPER_HORIZONTAL_PADDING}px;
`;

export const OfferText = styled.p`
  ${TYPOGRAPHY.OPEN_SANS.bold};
  font-size: 16px;

  color: ${BRAND_COLORS.white};
`;

export const Title = styled(H3)`
  text-align: center;
  color: ${BRAND_COLORS.black};
  font-size: 16px;
  font-weight: 700;
  margin: 0;
`;

export const SubTitle = styled(P)`
  font-size: 14px;
  text-align: center;
  margin: 0;
  color: ${BRAND_COLORS.darkGray};
`;
